import { render } from "./DetailListCard.vue?vue&type=template&id=94534e36&scoped=true"
import script from "./DetailListCard.vue?vue&type=script&lang=js"
export * from "./DetailListCard.vue?vue&type=script&lang=js"

import "./DetailListCard.vue?vue&type=style&index=0&id=94534e36&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-94534e36"]])

export default __exports__